<div *ngIf="visible && glass" [class.global]="global" class="common-box-glass"></div>
<div *ngIf="visible" [class.fixed-spinner]="fixed" [class.global]="global" class="common-box-spinner">
    <mat-progress-spinner [diameter]="fixed ? 100 : 60" class="inquiry-spinner" color="primary" mode="indeterminate">
    </mat-progress-spinner>

    <mat-progress-bar *ngIf="progress !== null" [value]="progress" mode="determinate"></mat-progress-bar>
    <div *ngIf="progress !== null && progressDescription" class="progress-description">{{progressDescription}}</div>
</div>
